export const state = {
  sideBarOpen: true
}

export const getters = {
  g_sideBarOpen: (state) => state.sideBarOpen
}

export const mutations = {
  toggleSideBar (state) {
    state.sideBarOpen = !state.sideBarOpen
  }
}
